const getClickTargetCoords = (event: any) => {
    var offsetLeft = event.target.offsetLeft;
    var offsetTop = event.target.offsetTop;
    return { x: offsetLeft, y: offsetTop}
}

export default getClickTargetCoords;